import { useContext } from "react";

import { TourContext, type TourContextValue } from "./TourProvider";

/**
 * Access the tour API from any component beneath `<TourProvider>`.
 *
 * @example
 *   const { startTour, isTourCompleted } = useTour();
 *   useEffect(() => {
 *     if (!isTourCompleted("first-login")) startTour("first-login");
 *   }, [isTourCompleted, startTour]);
 */
export function useTour(): TourContextValue {
  const ctx = useContext(TourContext);
  if (!ctx) {
    throw new Error("useTour() must be used within a <TourProvider>");
  }
  return ctx;
}
